// extracted by mini-css-extract-plugin
module.exports = {"cookiesSettingWrapper":"settingList_cookiesSettingWrapper__V6vNx","title":"settingList_title__mrdQf","status":"settingList_status__Xf2rO","content":"settingList_content__X4Pn2"};